module.exports = __webpack_public_path__ + "img/prt0007.prt.9174519c.jpg";